import { render, staticRenderFns } from "./SmallRecipeCards.vue?vue&type=template&id=2300cfcf&"
import script from "./SmallRecipeCards.vue?vue&type=script&lang=js&"
export * from "./SmallRecipeCards.vue?vue&type=script&lang=js&"
import style0 from "./SmallRecipeCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports